export function validar_simulador($where){
    const   $nombres        = $where.find('[name="nombres"]')
        ,   $telefono       = $where.find('[name="telefono"]')
        ,   $idTEvento      = $where.find('[name="idTEvento"]')
        ,   $fechaEvento    = $where.find('[name="fechaEvento"]')
        ,   $email          = $where.find('[name="email"]')
        ,   $idResp         = $where.find('[name="idResp"]')
        ,   $ninvAd         = $where.find('[name="ninvAd"]')
        ,   $ninvNi         = $where.find('[name="ninvNi"]')
        ,   $terminos       = $where.find('[name="terminos"]')
        ,   $polpriv        = $where.find('[name="polpriv"]')
        ,   num_reg         = /^([0-9])*$/
        ,   email_reg       = /^[a-zA-Z0-9_\.\-]+@[a-zA-Z0-9\-]+\.[a-zA-Z0-9\-\.]+$/

        ,   $idItemME        = $where.find('[name="idItemME"]')
        ,   $idItemMN        = $where.find('[name="idItemMN"]')
        ,   $idItemDC        = $where.find('[name="idItemDC"]')
        ,   $idItemFT        = $where.find('[name="idItemFT"]')
        

    
    if(!$terminos.prop('checked')){
        putErrMsg($terminos, 'Debes aceptar los términos y condiciones antes de continuar')
        return {status: false, errNumber: $terminos.attr('id')}
    } 

    if(!$polpriv.prop('checked')){
        putErrMsg($polpriv, 'Debes aceptar las políticas de tratamiento de datos antes de continuar')
        return {status: false, errNumber: $polpriv.attr('id')}
    } 

    let inputs= [$nombres, $telefono, $fechaEvento, $email, $ninvAd, $ninvNi]
    for(let i in inputs){
        let rta = genericValidation(inputs[i])
        if(rta !== true){
            return rta
        }
    }

    if($idTEvento.val() == null){
        putErrMsg($idTEvento, 'Debes seleccionar un tipo de evento antes de continuar')
        return {status: false, errNumber: $idTEvento.attr('id')}
    }

    if($idResp.val() == null && $idResp.length != 0){
        putErrMsg($idResp, 'Debes seleccionar un local antes de continuar')
        return {status: false, errNumber: $idResp.attr('id')}
    }

    if($idItemME.length != 0){
        if($idItemME.val() == null){
            putErrMsg($idItemME, 'Debes seleccionar un plato del menú antes de continuar')
            return {status: false, errNumber: $idItemME.attr('id')}
        }
    }
    if($idItemMN.length != 0){
        if($idItemMN.val() == null){
            putErrMsg($idItemMN, 'Debes seleccionar un tipo de mesa antes de continuar')
            return {status: false, errNumber: $idItemMN.attr('id')}
        }
    }
    if($idItemDC.length != 0){
        if($idItemDC.val() == null){
            putErrMsg($idItemDC, 'Debes seleccionar un tipo de decoración antes de continuar')
            return {status: false, errNumber: $idItemDC.attr('id')}
        }
    }
    if($idItemFT.length != 0){
        if($idItemFT.val() == null){
            putErrMsg($idItemFT, 'Debes seleccionar un tipo de fotografía de continuar')
            return {status: false, errNumber: $idItemFT.attr('id')}
        }
    }

    // Correo
    if(!email_reg.test($email.val().trim())){
        putErrMsg($emai, 'El formato de e-mail no es válido')    
        return {status: false, errNumber: $email.attr('id')}
    }
    return {status: true}
}

function genericValidation($input){
    const num_reg       = /^([0-9])*$/
    if($input.get(0).nodeName == 'INPUT' || $input.get(0).nodeName == 'TEXTAREA'){
        if($input.attr('type') == 'number' && !num_reg.test($input.val().trim())){
            putErrMsg($input, 'El campo debe ser numérico')
            return {status: false, errNumber: $input.attr('id')}
        }
        else if($input.val().trim() === ''){
            putErrMsg($input, 'Este es un campo requerido')
            return {status: false, errNumber: $input.attr('id')}
        }
    }
    else  if($input.get(0).nodeName == 'SELECT'){
        if($input.val() == '' || $input.val() == null || $input.val() == 0 || $input.val() == null){
            putErrMsg($input, 'Debes seleccionar una opción antes de continuar')
            return {status: false, errNumber: $input.attr('id')}
        }
    }
    return true
}

export function putErrMsg($input, message){
    let $helper = $input.parent().find('.helper-text')
    if($helper.length != 0) $helper.remove()
    $input.removeClass('valid')
    $input.parent().append('<span class="helper-text" data-error="Obligatorio" data-success="Correcto">' + message + '</span>')
    $input.focus()
    $input.goTo()
}

(function($) {
    $.fn.goTo = function(callback) {
        $('html, body').animate({
            scrollTop: $(this).offset().top + 'px'
        }, 'fast', function(){
            if(typeof callback === 'function'){
                callback()
            }
        });
        return this; // for chaining...
    }
})(jQuery);


// WEBPACK FOOTER //
// ./src/js/include/validations.js